import React from 'react';
import { Typography, Popover, Stack, Button } from '@mui/material';
import styles from '../../../../custom/style.module.css';
import { CustomButton } from '../../../../custom/components';
import { Warning } from '@mui/icons-material';

const ConfirmModal = (props) => {
  return (
    <div>
      <Popover
        id={props.id}
        open={props.modal}
        anchorEl={props.anchorEl}
        onClose={props.onClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      ><div className={styles.p3}>
          <Stack direction='row' alignItems='center'>
            {props.warning &&
            <Warning color='warning' sx={{
              ml: 1,
              mr: 1,
              fontSize: 20,
            }} />}
            <Typography variant='caption'>{props.confirmMessage || 'Are you sure you want to delete this record?'}</Typography>
          </Stack>
          <Stack className={styles.pt3} spacing={1} direction='row'>
            {props.deleteType === 'stn' && (
              <>
                <Button
                  variant='contained'
                  size='small'
                  onClick={props.onConfirmStn}
                >
                  <Typography variant='caption' lineHeight='normal' fontWeight='bold'>{'Only this Station'}</Typography>
                </Button>
                <Button
                  variant='contained'
                  size='small'
                  onClick={props.onConfirm}
                >
                  <Typography variant='caption' lineHeight='normal' fontWeight='bold'>{'All Stations'}</Typography>
                </Button>
              </>
            )}
            {props.deleteType !== 'stn' &&  <CustomButton variant='contained' size='small' onClick={props.onConfirm}> <Typography variant='caption' lineHeight='normal' fontWeight='bold'>{props.confirmBtn|| 'Yes'}</Typography></CustomButton>}
            <CustomButton variant='outlined' size='small' onClick={props.onClose}> <Typography variant='caption' lineHeight='normal'>{props.closeBtn || 'No'}</Typography></CustomButton>
          </Stack>
        </div>
      </Popover>
    </div>
  );
};
export default ConfirmModal;